export default __webpack_public_path__ + "static/media/NVO-FE-MR.6b35adb4.jpg";